import { Leaf, Users, Shield } from "lucide-react";

// VIVA brand palette
export const VIVA = {
  green: "#65972A",       // primario
  greenDark: "#4E7A1F",   // hover/active
  greenMid: "#8AB05D",
  greenSoft: "#ADD29C",
  greenPale: "#C4E1B8",
  ink: "#1F2A1A",
  gray700: "#4A4A4A",
  gray500: "#6D6D6D",
  gray300: "#A3A3A3",
};

export const PILLAR = {
  E: { label: "Environmental", color: VIVA.green, text: "text-[#4E7A1F]", bg: "bg-[#EAF3DD]", icon: Leaf },
  S: { label: "Social", color: "#F59E0B", text: "text-amber-700", bg: "bg-amber-50", icon: Users },
  G: { label: "Governance", color: "#6366F1", text: "text-indigo-700", bg: "bg-indigo-50", icon: Shield },
};

// VIVA band colors — V7/V6 verdi VIVA, scala fino al rosso per V1
export const BAND_COLORS = {
  V7: "#4E7A1F", // ≥ 90 Leader (verde VIVA scuro)
  V6: "#65972A", // 80-89 Avanzato (verde VIVA primario)
  V5: "#8AB05D", // 70-79 Solido (verde VIVA medio)
  V4: "#D4B83A", // 60-69 Adeguato (giallo-oliva armonico)
  V3: "#E89638", // 50-59 Base (arancio caldo)
  V2: "#D85A30", // 35-49 Insufficiente
  V1: "#B83020", // < 35 Critico
};

export const BAND_LABEL = {
  V7: "Leader ESG",
  V6: "Avanzato",
  V5: "Solido",
  V4: "Adeguato",
  V3: "Base",
  V2: "Insufficiente",
  V1: "Critico",
};

export function assignBand(score) {
  if (score === null || score === undefined) return null;
  if (score >= 90) return "V7";
  if (score >= 80) return "V6";
  if (score >= 70) return "V5";
  if (score >= 60) return "V4";
  if (score >= 50) return "V3";
  if (score >= 35) return "V2";
  return "V1";
}
